import { Box, Grid, Theme, Typography } from '@quillbot/design-system';
import createStyles from '@mui/styles/createStyles';
import { makeStyles } from '@mui/styles';
import withTheme from '@mui/styles/withTheme';
// import 'lazysizes';
// import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // iconBg: {
    //   background: '#FFFFFF',
    //   borderRadius: '8px',
    //   maxWidth: '116px',
    //   maxHeight: '116px',
    //   padding: '18px',
    //   margin: '0px 25px 17px',
    // },

    descriptionTopContainer: {
      backgroundImage: `url('./images/theme/${theme.palette.mode}/summarizer/webTop.png')`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center 0px',
      padding: '21px 20px 70px 20px',
      textAlign: 'center',
      [theme.breakpoints.down(600)]: {
        padding: '57px 5px 59px 5px',
        backgroundImage: `url('./images/theme/${theme.palette.mode}/summarizer/mobileTop.png')`,
        backgroundPosition: 'center bottom',
      },
    },

    BoxBottomImageBg: {
      backgroundImage: `url('./images/theme/${theme.palette.mode}/summarizer/webBottom.png')`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center 0px',
      [theme.breakpoints.down(600)]: {
        backgroundImage: `url('./images/theme/${theme.palette.mode}/summarizer/mobileBottom.png')`,
        backgroundPosition: 'center center',
      },
    },

    descriptionTopContainerInner: {
      maxWidth: '830px',
      margin: 'auto',
      '&:before': {
        content: ' ',
        position: 'absolute',
        left: '0px',
        top: '0px',
      },

      '& h1': {
        marginBottom: '27px',
        [theme.breakpoints.down(600)]: {
          fontSize: '23px',
          lineHeight: 'normal',
          padding: '0px 20px',
        },
      },
    },

    waveBoxBottom: {
      backgroundImage: `url('./images/theme/${theme.palette.mode}/summarizer/waveBg.png')`,
      minHeight: '100px',
      backgroundRepeat: 'no-repeat',
      width: '100%',
      backgroundPosition: 'left top',
      backgroundSize: '100%',
      // marginTop: '-50px',
      [theme.breakpoints.down(900)]: {
        marginTop: '0px',
      },
      [theme.breakpoints.down(600)]: {
        minHeight: '50px',
      },
    },

    summarizeWavySection: {
      backgroundColor: theme.palette.grey[300],
      padding: '66px 0px 66px',
      [theme.breakpoints.down(600)]: {
        padding: '52px 0px 52px 0px',
      },
    },
    contentBox: {
      maxWidth: '500px',
      padding: '18px 8px 0px 8px',
      margin: 'auto',

      '& img': {
        maxWidth: '100%',
        marginBottom: '24px',
        [theme.breakpoints.down(1200)]: {
          flexDirection: 'column',
          marginBottom: '4px',
          marginLeft: '2px',
        },
      },
    },

    contentBoxText: {
      padding: '0px 5px',
      [theme.breakpoints.down(600)]: {
        textAlign: 'center',
        padding: '0px 0px',
      },
    },

    contentBoxMobile: {
      [theme.breakpoints.down(960)]: {
        marginTop: '35px',
      },
    },

    summrizerBoxHolder: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down(600)]: {
        flexDirection: 'column',
        paddingTop: '8px',
      },
    },

    imageBoxHolder: {
      padding: '18px',
      borderRadius: '8px',
      width: '120px',
      margin: '0px auto 20px',
    },

    summrizerToolBox: {
      maxWidth: '126px',
      margin: '0px 25px',
      fontSize: '20px',
      textAlign: 'center',
      fontWeight: 600,

      '& span': {
        display: 'block',
        width: '100%',
        maxWidth: '116px',
        margin: 'auto',
        [theme.breakpoints.down(600)]: {
          maxWidth: '100%',
          marginTop: '-4px',
        },
      },

      [theme.breakpoints.down(600)]: {
        fontSize: '15px',
        maxWidth: '200px',
        marginBottom: '12px',
      },

      '&:last-child': {
        marginBottom: '6px',
      },
    },
  })
);

function SummarizerExplanation({ theme }: { theme: Theme }) {
  const classes = useStyles();
  return (
    <>
      <div className="container">
        <Grid container>
          <Grid item className={classes.descriptionTopContainer} xs={12}>
            <div className={classes.descriptionTopContainerInner}>
              <h1 className="pageTitle">Summarize any text with a click of a button</h1>

              <Typography component="h2">
                QuillBot&apos;s summarizer can condense articles, papers, or documents down to the
                key points instantly. Our AI uses natural language processing to locate critical
                information while maintaining the original context.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>

      <Grid container className={classes.summarizeWavySection}>
        <Grid item xs={12}>
          <div className="container">
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  component="h3"
                  style={{
                    textAlign: 'center',
                    padding: '0px 30px',
                    fontSize: '20px',
                  }}
                >
                  You can summarize in two ways:
                </Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Box className={`${classes.contentBox}`}>
                  <div>
                    <img
                      // key={theme.palette.type}
                      src={`/images/theme/${theme.palette.mode}/summarizer/keySentences.svg`}
                      alt="Key Sentences"
                      width={500}
                      height={338}
                      //  className="lazyload"
                    />
                  </div>
                  <Typography component="h3" className={classes.contentBoxText}>
                    <strong>Key Sentences </strong>gives you a bullet point list of the most
                    important sentences. You can change how many bullets you get by adjusting the
                    summary length slider.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Box className={`${classes.contentBox} ${classes.contentBoxMobile}`}>
                  <div>
                    <img
                      // key={theme.palette.type}
                      src={`/images/theme/${theme.palette.mode}/summarizer/paragraph.svg`}
                      alt="Paragraph mode"
                      width={500}
                      height={338}
                      // className="lazyload"
                    />
                  </div>
                  <Typography component="h3" className={classes.contentBoxText}>
                    <strong>Paragraph mode</strong> gives you a unique paragraph summarizing the
                    content. You can also control how long your results are by using the summary
                    length slider.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      <div className={classes.waveBoxBottom} />

      <Grid container>
        <Grid item xs={12}>
          <div className={` ${classes.BoxBottomImageBg} container`}>
            <Grid container style={{ textAlign: 'center' }}>
              <Grid item xs={12}>
                <Typography style={{ margin: '30px 0px 15px' }} component="h3">
                  Whether you have a...{' '}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Box className={classes.summrizerBoxHolder}>
                  <Box className={classes.summrizerToolBox}>
                    <Box boxShadow={2} className={classes.imageBoxHolder}>
                      <img
                        // key={theme.palette.type}
                        src="/images/Summarizer/newsArticle.svg"
                        alt="News Article"
                        width={65}
                        height={60}
                        // className="lazyload"
                      />
                    </Box>
                    <span>News Article</span>
                  </Box>
                  <Box className={classes.summrizerToolBox}>
                    <Box boxShadow={2} className={classes.imageBoxHolder}>
                      <img
                        // key={theme.palette.type}
                        src="/images/Summarizer/researchPaper.svg"
                        alt="Research Paper"
                        width={65}
                        height={60}
                        // className="lazyload"
                      />
                    </Box>
                    <span>Research Paper</span>
                  </Box>
                  <Box className={classes.summrizerToolBox}>
                    <Box boxShadow={2} className={classes.imageBoxHolder}>
                      <img
                        // key={theme.palette.type}
                        src="/images/Summarizer/confusingParagraph.svg"
                        alt="Confusing Paragraph"
                        width={65}
                        height={60}
                        //  className="lazyload"
                      />
                    </Box>
                    <span>Confusing Paragraph</span>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Typography style={{ margin: '27px 0px 70px' }} component="h3">
                  The summarizer tool will help you get the information that you need.
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default withTheme<Theme, React.FunctionComponent<{ theme: Theme }>>(SummarizerExplanation);
